module.exports = __webpack_public_path__ + "static/media/sherlockHolmes.6f301d18.ttf";